import client from './client';

export interface UserProfile {
	id: number;
	name: string;
}

export interface User {
	id: number;
	email: string;
	name: string;
	active: boolean;
	profile: UserProfile;
}

export interface CreatedUser {
	id: number;
	email: string;
	name: string;
	password: string;
}

export interface ContractWithAssignment {
	id: number;
	name: string;
	assigned: boolean;
}

const usersApi = {
	getUsers: (search?: string) => {
		const params = search ? { search } : undefined;
		return client.get<{ users: User[] }>('/admin/getUsers', {
			params,
		});
	},

	createUser: (data: {
		email: string;
		name: string;
		profileId: number;
	}) => client.post<{ user: CreatedUser }>('/admin/createUser', data),

	toggleUserActive: (userId: number, active: boolean) =>
		client.post<{ id: number; active: boolean }>(
			'/admin/setUserActive',
			{ id: userId, active },
		),

	getUserContracts: (userId: number) =>
		client.get<{ contracts: ContractWithAssignment[] }>(
			'/admin/getUserContracts',
			{ params: { userId } },
		),

	updateUserContracts: (
		userId: number,
		contractIds: number[],
	) =>
		client.post<{ contractIds: number[] }>(
			'/admin/setUserContracts',
			{ userId, contractIds },
		),

	getProfiles: () =>
		client.get<{ profiles: UserProfile[] }>(
			'/admin/getProfiles',
		),

	changePassword: (userId: number) => {
		return client.post<{ success: boolean; password: string }>(
			'/admin/changeUserPassword',
			{ userId },
		);
	},

	impersonate: (userId: number) =>
		client.post<{ handoffToken: string; webVueUrl: string }>(
			'/admin/impersonateUser',
			{ userId },
		),
};

export default usersApi;
